import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import HeberOffice from "./pages/HeberOffice";
import Appointments from "./pages/Appointments";
import Blog from "./pages/Blog";
import Forms from "./pages/Forms";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/about/" component={About} />
      <Route path="/about" component={About} />
      <Route path="/services/" component={Services} />
      <Route path="/services" component={Services} />
      <Route path="/services/:slug/" component={ServiceDetail} />
      <Route path="/services/:slug" component={ServiceDetail} />
      <Route path="/heber-office/" component={HeberOffice} />
      <Route path="/heber-office" component={HeberOffice} />
      <Route path="/appointments/" component={Appointments} />
      <Route path="/appointments" component={Appointments} />
      <Route path="/contact/" component={Appointments} />
      <Route path="/contact" component={Appointments} />
      <Route path="/blog/" component={Blog} />
      <Route path="/blog" component={Blog} />
      <Route path="/articles/" component={Articles} />
      <Route path="/articles" component={Articles} />
      <Route path="/forms/" component={Forms} />
      <Route path="/forms" component={Forms} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
import Articles from "./pages/Articles";
